import axios from 'axios';

export async function getPendingDataRequestCount(): Promise<App.DataRequests.Data.PendingDataRequestCountData> {
  return axios.get(route('api.data-requests.pending-count')).then((res) => res.data);
}
